import React, { PropsWithChildren } from 'react';

import { classNames } from '@/helpers/classNames';
import { Dialog, useMediaQuery } from '@material-ui/core';

import constants from '../../../theme/exportedVariables.module.scss';
import { AsaphDialogHeaderButton } from '../Dialog';
import styles from './BottomCard.module.scss';

export interface BottomCardProps {
	className?: string;
	title?: string;
	hasCloseButton?: boolean;
	closeButtonLabel?: string;
	onClose?: () => void;
}

export const BottomCard: React.FC<PropsWithChildren<BottomCardProps>> = ({
	className,
	title,
	children,
	hasCloseButton,
	closeButtonLabel = 'Close',
	onClose,
}) => {
	const fullScreen = !useMediaQuery(`(min-width: ${constants.sizeTablet}`);

	return (
		<Dialog
			fullScreen={fullScreen}
			scroll="paper"
			classes={{
				paper: styles['dialog-paper'],
				scrollPaper: styles['dialog'],
				paperFullScreen: styles['dialog-paper-full-screen'],
			}}
			onClose={() => onClose?.()}
			open={true}
		>
			<div className={classNames([styles['root'], className])}>
				{title && (
					<div className={styles['header']}>
						<div className={styles['leading']}>
							{hasCloseButton ? (
								<AsaphDialogHeaderButton
									type="text"
									label={closeButtonLabel}
									handlePress={() => onClose?.()}
								/>
							) : null}
						</div>
						<div className={styles['title']}>{title}</div>
						<div className={styles['trailing']} />
					</div>
				)}

				{children}
			</div>
		</Dialog>
	);
};

export const BottomCardForm: React.FC = ({ children }) => {
	return <div className={styles['form']}>{children}</div>;
};

export const BottomCardAction: React.FC = ({ children }) => {
	return <div className={styles['action']}>{children}</div>;
};

export const BottomCardOverlay: React.FC<{
	onClick?: () => void;
	isActive?: boolean;
}> = ({ onClick, isActive }) => {
	return (
		<div
			className={classNames([
				styles['overlay'],
				isActive && styles['active'],
			])}
			onClick={onClick}
		/>
	);
};
